import { inject, type Reactive } from 'vue';
import type { AppContext } from '@/types';

// Usage:
// ---
// const app = useApp()
// to retain reactivity
// ---
// const { site } = useApp()
// you may use destructuring when reactivity is not needed

export default function useApp(): AppContext {
    return inject('context') as Reactive<AppContext>;
}
